export default {
	TITLE: 'Addon recommendations',
	ADDON_RECOMMENDATION_ADDED: 'Addon recommendation added',
	ADDON_RECOMMENDATION_EDITED: 'Addon recommendation edited',
	ADDON_RECOMMENDATION_DELETED: 'Addon recommendation deleted'
};
